import React from 'react';

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
      <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-auto my-8 sm:my-16">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Obchodní podmínky</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold"
          >
            ×
          </button>
        </div>
        
        <div className="prose max-w-none text-gray-900">
          <h3 className="text-lg font-semibold mb-3 text-gray-900">Podmínky pro zprostředkování telekomunikačních služeb a provoz internetové stránky</h3>
          <p className="mb-4 text-gray-800"><strong>Verze: 1, účinná od 25. 7. 2025</strong></p>
          
          <p className="mb-4 text-gray-800">
            Tyto Podmínky pro zprostředkování telekomunikačních služeb a provoz internetové stránky (dále jen „Podmínky") zejména popisují, jakým způsobem společnost Vyjednáme, s.r.o., IČO 21377596, DIČ CZ21377596, se sídlem Příčná 1892/4, 110 00 Praha – Nové Město, zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, sp. zn. C 400161, základní kapitál 1 000 Kč, (dále jen „Vyjednáme"), vykonává zprostředkovatelskou činnost a provozuje internetové stránky.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme vykonává zprostředkovatelskou činnost v oblasti telekomunikačních služeb jako obchodní partner společnosti Vodafone Czech Republic a.s.
          </p>
          
          <p className="mb-4 text-gray-800">
            Podmínky mohou být kdykoliv ze strany Vyjednáme měněny vyvěšením nové verze Podmínek na webových stránkách www.vyjedname.cz.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">1. OBECNÁ A ÚVODNÍ UJEDNÁNÍ</h4>
          <p className="mb-4 text-gray-800">
            Vyjednáme je obchodní společností zabývající se zejména poskytováním služeb call centra a provozováním webových stránek (včetně Webových stránek), prostřednictvím kterých je Vyjednáme schopno Zájemcům zprostředkovat možnost uzavření smlouvy o poskytování telekomunikačních služeb (dále jen „Smlouva o službě").
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme svým jménem a na svou odpovědnost vykonává zprostředkovatelskou činnost.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme můžete kontaktovat:
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-800">
            <li>na adrese sídla: Příčná 1892/4, 110 00 Praha – Nové Město</li>
            <li>prostřednictvím elektronické adresy: info@vyjedname.cz</li>
            <li>prostřednictvím webových stránek: www.vyjedname.cz</li>
          </ul>
          
          <p className="mb-4 text-gray-800">
            Webové stránky smí být využívány pouze za účelem, pro který byly vytvořeny, tedy pro získávání informací pro osobní užití a případně i pro vyplnění formuláře za účelem uzavření Smlouvy o službě.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme jedná se Zájemci jako zprostředkovatel telekomunikačních služeb a vykonává zprostředkovatelskou činnost zejména prostřednictvím svého call centra.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme je oprávněno Zájemce kontaktovat a poskytovat mu službu informačního a srovnávacího servisu, v rámci které může být Zájemci nabídnuto srovnání produktů společnosti Vodafone a uzavření Smluv.
          </p>
          
          <p className="mb-4 text-gray-800">
            V rámci uvedených činností je Vyjednáme v postavení správce osobních údajů. Podrobnosti ke zpracování osobních údajů jsou uvedeny v zásadách ochrany osobních údajů dostupných na www.vyjedname.cz.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme neodpovídá za výpadky nebo dostupnost Webových stránek.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">2. OBSAH WEBOVÝCH STRÁNEK</h4>
          <p className="mb-4 text-gray-800">
            Vyjednáme si vyhrazuje právo Webové stránky kdykoliv měnit, a to bez nutnosti předchozího upozornění.
          </p>
          
          <p className="mb-4 text-gray-800">
            Pokud to Vyjednáme umožní, může Zájemce uzavřít Smlouvu o službě prostřednictvím Webové stránky, to však může být technicky podmíněno doložením některých údajů a podkladů, které jsou k uzavření Smlouvy o službě potřeba.
          </p>
          
          <p className="mb-4 text-gray-800">
            Zájemci nesmí Webové stránky měnit, upravovat nebo do nich zasahovat, případně je rozmnožovat, rozšiřovat, kopírovat, vydávat za vlastní apod. Zájemci dále nesmí k Webovým stránkám přistupovat za využití nástrojů třetích stran, které spočívají v automatizovaném čtení a vytěžování informací. Zájemci rovněž nejsou oprávněni zadávat data do Webových stránek za využití nástrojů třetích stran, které spočívají v automatizovaném vyplňování údajů. Zájemci smí přistupovat k Webovým stránkám pouze individuálně a výhradně za účelem zjištění zájmu o službu nebo za účelem využití služby. Webové stránky jsou jako autorská díla chráněna dle zákona č. 121/2000 Sb., autorský zákon.
          </p>
          
          <p className="mb-4 text-gray-800">
            V rámci Webových stránek jsou zobrazovány vybrané produkty a služby, nicméně v žádném případě se nejedná o příslib nebo návrh uzavření Smlouvy o službě za podmínek zveřejněných na Webových stránkách.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">3. VÝBĚR PRODUKTU</h4>
          <p className="mb-4 text-gray-800">
            Zájemce vyplněním formuláře na Webových stránkách žádá o provedení kalkulace nebo předběžného návrhu nabídky, která bude poskytnuta prostřednictvím telefonního hovoru nebo prostřednictvím Webové stránky, pakliže to Vyjednáme umožní.
          </p>
          
          <p className="mb-4 text-gray-800">
            Zájemce vyplněním formuláře na Webových stránkách rovněž projevuje zájem o zprostředkování Smlouvy o službě včetně provedení dalších přípravných prací s tím spojených.
          </p>
          
          <p className="mb-4 text-gray-800">
            Zobrazované údaje vycházejí z veřejně dostupných i neveřejných zdrojů a jsou pouze orientační.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme nemusí po vyplnění formuláře na Webové stránce zobrazovat všechny dostupné produkty. Vyjednáme může prostřednictvím Webové stránky zobrazovat pouze vybrané produkty.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">4. ZPROSTŘEDKOVÁNÍ VYBRANÉ SMLOUVY O SLUŽBĚ</h4>
          <p className="mb-4 text-gray-800">
            Vyjednáme sám a na svou odpovědnost určuje okruh Zájemců, které osloví ohledně uzavření Smlouvy o službě a kterým Smlouvu zprostředkuje, a k tomuto účelu sám vytváří databázi osobních údajů těchto Zájemců.
          </p>
          
          <p className="mb-4 text-gray-800">
            Zprostředkování probíhá zejména za využití prostředků komunikace na dálku, případně prostředky, kterými to Vyjednáme umožní. Smlouva o službě může být uzavřena zejména telefonicky nebo prostřednictvím Webových stránek.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme provádí zprostředkování jako službu pro klienty svých obchodních partnerů, kteří mu za poskytnutí této služby platí odměnu. Vyjednáme však neuzavírá Smlouvu o službě za Zájemce ani za Dodavatele, pouze zprostředkovává příležitost k uzavření Smlouvy.
          </p>
          
          <p className="mb-4 text-gray-800">
            Výběr konkrétního produktu je vždy na svobodné vůli Zájemce.
          </p>
          
          <p className="mb-4 text-gray-800">
            Vyjednáme žádným způsobem nezaručuje, že Dodavatel se Zájemcem uzavře Smlouvu o službě. Vyjednáme zároveň žádným způsobem neodpovídá za obsah Smlouvy ani za samotné její plnění, za což je odpovědný Dodavatel.
          </p>
          
          <h4 className="font-semibold mt-6 mb-2 text-gray-900">5. ZÁVĚREČNÁ UJEDNÁNÍ</h4>
          <p className="mb-4 text-gray-800">
            Případné spory budou řešeny u příslušného soudu v České republice. Spotřebitelské spory mohou být řešeny rovněž mimosoudní cestou, zejména před Českou obchodní inspekcí (<a href="https://www.coi.cz/" className="text-blue-600 hover:underline">https://www.coi.cz/</a>). Stížnost můžete podat prostřednictvím formuláře, který je dostupný na <a href="https://www.coi.cz/mimosoudni-reseni-spotrebitelskych-sporu-adr/" className="text-blue-600 hover:underline">https://www.coi.cz/mimosoudni-reseni-spotrebitelskych-sporu-adr/</a>.
          </p>
          
          <p className="mb-4 text-gray-800">
            Zájemce může využít rovněž platformu pro řešení sporů online, která je zřízena Evropskou komisí (<a href="https://ec.europa.eu/consumers/odr/" className="text-blue-600 hover:underline">https://ec.europa.eu/consumers/odr/</a>) či kontaktovat Evropské spotřebitelské centrum Česká republika, se sídlem Štěpánská 567/15, 120 00 Praha 2 (<a href="https://www.evropskyspotrebitel.cz" className="text-blue-600 hover:underline">https://www.evropskyspotrebitel.cz</a>).
          </p>
          
          <p className="mb-4 text-gray-800">
            Neplatnost jakéhokoliv ujednání těchto Podmínek nezpůsobuje neplatnost těchto Podmínek jako celku.
          </p>
          
          <p className="mb-4 text-gray-800">
            Smlouva o informačním a srovnávacím servisu je uzavírána na dobu neurčitou a může být kdykoliv vypovězena. Výpovědní doba činí 10 pracovních dnů.
          </p>
          
          <p className="mb-4 text-gray-800">
            Od smlouvy o informačním a srovnávacím servisu lze odstoupit do 14 dnů ode dne jejího uzavření.
          </p>
          
          <p className="mb-4 text-gray-800">
            Podmínky mohou být ze strany Vyjednáme kdykoliv měněny vyvěšením nové verze Podmínek.
          </p>
          
          <div className="mt-6 pt-4 border-t">
            <p className="text-sm text-gray-600">
              <strong>Kontaktní údaje:</strong><br />
              Vyjednáme, s.r.o.<br />
              Příčná 1892/4, 110 00 Praha – Nové Město<br />
              IČO: 21377596<br />
              DIČ: CZ21377596<br />
              E-mail: info@vyjedname.cz<br />
              Web: www.vyjedname.cz
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
